import React from 'react';

import './PersonalDashboardBanner.scss';
import icons from '../../shared/assets/icons';
import sendEvent from '../../helpers/tracking';
import { useMobile } from '../../helpers/hooks';

const { Location, Cross, Edit, Child } = icons;

const tracking = {
  uitloggen: {
    mobile: ['menu-dashboard-mobile', 'menu-dashboard-uitloggen'],
    desktop: ['menu-dashboard-desktop', 'menu-dashboard-uitloggen']
  },
  profileSettings: {
    mobile: ['menu-dashboard-mobile', 'menu-dashboard-mobile-profile-settings'],
    desktop: [
      'menu-dashboard-desktop',
      'menu-dashboard-desktop-profile-settings'
    ]
  }
};

export default function PersonalDashboardBanner(props) {
  const { status, provider, displayName, phaseNumeric, profilePicture } =
    props.user;

  const [isMobile, setIsMobile] = useMobile();

  const trackingKey = isMobile ? 'mobile' : 'desktop';

  const week = userWeek(status, phaseNumeric);

  return (
    <section id="personalDashboardBanner">
      <div id="personalDashboardBanner_content">
        <div id="personalDashboardBanner_image">
          <img src={profilePicture} alt="user-image" />
        </div>

        <div id="personalDashboardBanner_userdata">
          <p id="personalDashboardBanner_username">{displayName}</p>

          <p>
            {week && <span id="personalDashboardBanner_userweek">{week}</span>}

            <a
              href="/profile-settings?scrollTo=profileSettings_list"
              onClick={() =>
                sendEvent(...tracking.profileSettings[trackingKey])
              }
            >
              <Edit />
            </a>
          </p>

          <button
            onClick={() => {
              sendEvent(...tracking.uitloggen[trackingKey]);

              logout();
            }}
          >
            Uitloggen
          </button>
        </div>

        <div id="personalDashboardBanner_provider">
          <p>
            <Location />

            {provider && (
              <React.Fragment>
                {provider.addressline1}

                {provider.city && `, ${provider.city}`}
              </React.Fragment>
            )}
          </p>

          <p>
            <Cross />

            {provider && provider.displayName}
          </p>
        </div>
      </div>
    </section>
  );

  function userWeek(status, phaseNumeric) {
    if (['PREPARING', 'OTHER'].includes(status)) return;

    if (status === 'PREGNANT') return `Week ${phaseNumeric}`;

    if (phaseNumeric <= 9)
      return (
        <span>
          <Child />
          Jouw baby is {phaseNumeric} {phaseNumeric > 1 ? 'weken' : 'week'}
        </span>
      );
  }

  function logout() {
    document.cookie = 'jwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'PNLSID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    location.href = props.logoutUrl;
  }
}
